import * as AccountsActions from './accounts.actions';
import {REQUEST_USER_ACCOUNTS_SUCCESS} from '../user/user.actions';

export const INITIAL_STATE = {
  account_roles: [],
  subaccounts: [],
  viewing_account: null,
  loading_account: null,
  loading_account_error: null,
  updating_subaccount: false,
  updating_subaccount_error: false,
  creating_subaccount: false,
  create_sub_account_error: null
};

export const ACCOUNTS_STATE_NAME = 'accounts';

export default (state = INITIAL_STATE, {type, payload}) => {
  switch (type) {
    case AccountsActions.GET_ACCOUNT:
      return {...state, loading_account: payload.id, loading_account_error: false};
    case AccountsActions.GET_ACCOUNT_SUCCESS:
      return {
        ...state,
        viewing_account: payload,
        loading_account: null,
        loading_account_error: null
      };
    case AccountsActions.GET_ACCOUNT_FAIL:
      return {
        ...state,
        loading_account: null,
        loading_account_error: payload,
        viewing_account: null
      };
    case REQUEST_USER_ACCOUNTS_SUCCESS: {
      return {...state, subaccounts: [...payload.currentAccount.accounts]};
    }
    case AccountsActions.UPDATE_SUBACCOUNT:
    case AccountsActions.UPDATE_INHERITED_ROLES:
      return {
        ...state,
        updating_subaccount: true,
        updating_subaccount_error: null
      };
    case AccountsActions.UPDATE_SUBACCOUNT_SUCCESS: {
      let subaccounts = [...state.subaccounts].map(account => {
        if (account.id === payload.id) {
          account = payload;
        }

        return account;
      });
      return {
        ...state,
        subaccounts: [...subaccounts]
      };
    }
    case AccountsActions.UPDATE_INHERITED_ROLES_SUCCESS:
      return {
        ...state,
        updating_subaccount: false,
        updating_subaccount_error: null
      };
    case AccountsActions.CREATE_SUBACCOUNT:
      return {
        ...state,
        creating_subaccount: true,
        create_subaccount_error: null
      };
    case AccountsActions.CREATE_SUBACCOUNT_SUCCESS:
      return {
        ...state,
        subaccounts: [...state.subaccounts, payload],
        creating_subaccount: false,
        create_subaccount_error: null
      };
    case AccountsActions.CREATE_SUBACCOUNT_FAIL: {
      let errorMessage = 'Something went wrong creating a subaccount';

      if (payload.data && payload.data.message) {
        errorMessage = payload.data.message;
      }

      if (payload.status === 403) {
        errorMessage = 'You do not have sufficient privileges to create sub accounts';
      }

      return {
        ...state,
        creating_subaccount: false,
        create_subaccount_error: errorMessage
      };
    }
    case AccountsActions.GET_ROLES_SUCCESS:
      return {
        ...state,
        account_roles: payload.filter(role => role.id !== '-1').sort((a, b) => a.name - b.name)
      };

    default:
      return state;
  }
};
